import { useMutation } from '@apollo/client';
import { useLingui } from '@lingui/react';

import { Form, Input } from 'antd';
import type { FormInstance } from 'antd/es/form';
import React, { useEffect, useState } from 'react';

import { GQL_CREATE_TASK_INTERN } from '~/gql/task/task';

import { authClient } from '~/helpers/apollo';
import { useAuth } from '~/helpers/store/auth';

import ModalCustom from '~/pages/components/ui/ModalCustom';

type IProps = {
  title: string;
  isOpen: boolean;
  projectId: number;
  confirm: () => void;
  close: () => void;
};

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

function AddTaskIntern({ title, isOpen, confirm, close, projectId }: IProps) {
  const { i18n } = useLingui();
  const { payload } = useAuth();

  const [taskName, setTaskName] = useState<string>('');

  const formRef = React.useRef<FormInstance>(null);

  const [createTaskIntern] = useMutation(GQL_CREATE_TASK_INTERN, {
    client: authClient,
  });

  useEffect(() => {
    formRef.current?.resetFields();
  }, []);

  async function submit() {
    if (!payload?.sub || !taskName) return;

    const { data: _data } = await createTaskIntern({
      variables: {
        createTaskInternInput: {
          projectId: projectId,
          name: taskName,
        },
      },
    });

    if (_data) {
      confirm();
    } else {
      close();
    }
  }

  return (
    <ModalCustom
      confirmDisabled={!taskName}
      title={title}
      isOpen={isOpen}
      confirm={submit}
      close={close}
    >
      <Form
        {...layout}
        ref={formRef}
        name="add-task"
        initialValues={{ taskName: '' }}
        style={{ maxWidth: 600 }}
      >
        <Form.Item
          name="taskName"
          label={i18n._('form.task-name')}
          rules={[
            {
              required: true,
              message: i18n._('form.task-name.placeholder'),
            },
          ]}
        >
          <Input
            placeholder={i18n._('form.task-name.placeholder')}
            onChange={(e) => setTaskName(e.target.value)}
          />
        </Form.Item>
      </Form>
    </ModalCustom>
  );
}

export default AddTaskIntern;
